export function hasOffers(product): boolean {
  const { variants = [] } = product
  return variants.some(({ offers = [] }) => offers.length > 0)
}

export function hasImage(product) {
  return !!(product && product.images && product.images[0])
}
